<template>
  <div class="library__card card" @click.stop="downloadPricing">
    <div class="card__logo-container">
      <div class="card__logo-wrapper">
        <img class="card__logo" :src="decode(vendor.logoURL)" v-if="vendor.logoURL">
        <span class="fa fa-adjust card__placeholder" aria-hidden="true" v-else></span>
      </div>
    </div>
    <div class="card__title">{{ vendor.name }}</div>
    <div class="card__description">&nbsp;</div>
    <div class="card__view-btn">Download <span class="glyphicon glyphicon-download" aria-hidden="true"></span></div>
  </div>
</template>

<script>
import FuelUtilities from "../../utils/FuelUtilities.js";

export default {
  name: 'PricingCard',
  mixins: [FuelUtilities],
  data() {
    return {
      modalKey: 'pricingModal',
    };
  },
  props: {
    vendor: Object,
  },
  computed: {
    modalData() {
      return { ...this.vendor };
    },
  },
  methods: {
    downloadPricing() {
      if (!this.downloadInProgress) {
        this.$store.dispatch('library/downloadPricing', this.vendor.name);
      } else {
        return;
      }
    },
    activateModal() {
      this.$store.dispatch('main/setProperty', { key: 'modalData', value: this.modalData });
      this.$store.dispatch('main/showModal', this.modalKey);
    },
  },
};
</script>

<style scoped>
  .card__view-btn span {
    margin-left: 8px;
  }
</style>
